import { Component, Input, OnChanges } from '@angular/core';

@Component({
	selector: 'app-leads-show-history',
	templateUrl: './leads-show-history.component.html',
	styleUrls: ['./leads-show-history.component.css'],
})
export class LeadsShowHistoryComponent implements OnChanges {
	@Input() history: Array<any> = [];
	@Input() users: Array<any> = [];

	constructor() {}

	ngOnChanges(): void {
		if (this.history == undefined || this.users == undefined) {
			return;
		}
		this.history.forEach((obj) => {
			const user = this.users.find((objFind) => objFind.id == obj.user);
			obj.user = user ? user.name : '?';
		});
	}
}
